import { UNIT_TRANSLATE } from 'constants/translate'
import { EKPIUnit } from 'enums/kpi'

interface IFormatOptions {
  unit?: EKPIUnit
  prefix?: string
  suffix?: string
}

class NumberUtil {
  static format(num?: number | string | null, options?: IFormatOptions): string {
    let prefix = options?.prefix || ''
    let suffix = options?.suffix || ''

    if (options?.unit === EKPIUnit.PERCENT) {
      suffix = UNIT_TRANSLATE[options.unit]
    } else if (options?.unit === EKPIUnit.SGD) {
      prefix = UNIT_TRANSLATE[options.unit]
    }

    if (typeof num === 'number' && !isNaN(num)) {
      return prefix + num.toLocaleString() + suffix
    }
    if (typeof num === 'string' && !isNaN(Number(num))) {
      return prefix + Number(num).toLocaleString() + suffix
    }
    return ''
  }

  static fuzzyCompare(num1: number, num2: number): boolean {
    const lowerBound = Math.floor(num2) - 1
    const upperBound = Math.floor(num2) + 1

    return num1 >= lowerBound && num1 <= upperBound
  }
}

export default NumberUtil
